// extracted by css-extract-rspack-plugin
export default {"root":"root-TAcArc","upper":"upper-K8TifC"};